import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useUserMainGoalHttp } from '@/core/api/user-main-goals'
import { UserMainGoal, UserMainGoalPayload } from '@/core/models/user-main-goal'

export type UserMainGoalCollection = {
    data: Array<UserMainGoal>,
    meta?: MetaPayload,
    links?: any
}

const state: UserMainGoalCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const userMainGoalCollection: Module<UserMainGoalCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: UserMainGoalCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: UserMainGoalPayload) => {
                state.data.push(new UserMainGoal(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
        remove: (state: UserMainGoalCollection, id: number) => {
            state.data = state.data.filter(item => item.id !== id)
        },
    },
    actions: {
        get: <T>(context: any, payload: { userId: number, params?: any }): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useUserMainGoalHttp(payload.userId)
                    .get(payload.params || {})
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
        delete: <T>(context: any, payload: { userId: number, id: number }): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useUserMainGoalHttp(payload.userId)
                    .del(payload.id)
                    .then((data: any) => {
                        context.commit('remove', payload.id)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
    },
    getters: {
        get: (state: UserMainGoalCollection): UserMainGoalCollection => {
            return state
        }
    }
}